import {ThumbFeedback} from "../components/Feedback";
import {v4 as uuidv4} from "uuid";
import {config} from "../environment";

type FeedbackProps = {
  system: string,
  location: string, // path to the page where the rating was given
  ref: string, // reference, e.g. to the feature being rated, a feature toggled test id or similar
  rating?: ThumbFeedback,
  comment?: string,
}

const clientId = uuidv4()

export async function postFeedback(ratingFeedback: FeedbackProps): Promise<Response> {
  const request = {clientId: clientId, ...ratingFeedback}
  const requestOption = {
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST',
    body: JSON.stringify(request)
  }

  return fetch(`${config.apiUrl}/api/feedback`, {
    ...requestOption,
  })
}